<template>
  <div>
    <List />
  </div>
</template>

<script>
import List from "../components/List";

export default {
  components: {
    List
  }
};
</script>

<style scoped></style>
